export function downloadBlob(data: Blob, fileName: string) {
  const url = window.URL.createObjectURL(data)
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', fileName)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // Clean up the object URL to prevent memory leaks
  window.URL.revokeObjectURL(url)
}
